var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "tr",
    { staticClass: "stage stage_row" },
    [
      _vm.isAccessAllow
        ? _c("StageName", {
            attrs: { stage: _vm.stage },
            on: {
              update: (stageName) =>
                _vm.$emit(
                  "updateStage",
                  _vm.stage.set("name", stageName, true)
                ),
              delete: function ($event) {
                return _vm.$emit("deleteStage")
              },
            },
          })
        : _c("td", { staticClass: "stage__col stage__col_name" }, [
            _c(
              "span",
              { staticClass: "stage-name-label__text text-truncate mr-1" },
              [_vm._v(_vm._s(_vm.stage.name))]
            ),
          ]),
      _vm._v(" "),
      _vm.isAccessAllow
        ? _c("StageRelated", {
            attrs: { stages: _vm.stages, stage: _vm.stage },
            on: {
              update: (relatedStageId) =>
                _vm.$emit(
                  "updateStage",
                  _vm.stage.setRelatedId(relatedStageId, _vm.stages, true)
                ),
            },
          })
        : _c("td", { staticClass: "stage__col stage__col_related" }, [
            _c("div", [_vm._v(_vm._s(_vm.stage.name || "Нет"))]),
          ]),
      _vm._v(" "),
      _vm.isAccessAllow
        ? _c("StageResponsible", {
            attrs: { responsibleUserId: _vm.stage.responsible },
            on: {
              update: (responsibleId) =>
                _vm.$emit(
                  "updateStage",
                  _vm.stage.set("responsible", responsibleId, true)
                ),
            },
          })
        : _c("td", { staticClass: "stage__col stage__col_responsible" }, [
            _c("div", [_vm._v(_vm._s(_vm.getResponsible()))]),
          ]),
      _vm._v(" "),
      _c(
        "td",
        { staticClass: "stage__col stage__col_date-start" },
        [
          _vm.stage.dateStart && _vm.hasAccess
            ? _c("Calendar", {
                attrs: { value: _vm.stage.dateStart },
                on: {
                  input: (dateStart) =>
                    _vm.$emit(
                      "updateStage",
                      _vm.stage.set("dateStart", dateStart, true)
                    ),
                },
              })
            : _vm.stage.dateStart
            ? _c("span", [
                _vm._v(_vm._s(_vm.formattedDate(_vm.stage.dateStart))),
              ])
            : _c("span", [_vm._v("не задано")]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "td",
        { staticClass: "stage__col stage__col_date-finish" },
        [
          _vm.stage.dateFinish && _vm.hasAccess
            ? _c("Calendar", {
                attrs: {
                  value: _vm.stage.dateFinish,
                  minDate: _vm.stage.dateStart || null,
                },
                on: {
                  input: (dateFinish) =>
                    _vm.$emit(
                      "updateStage",
                      _vm.stage.set("dateFinish", dateFinish, true)
                    ),
                },
              })
            : _vm.stage.dateFinish
            ? _c("span", [
                _vm._v(_vm._s(_vm.formattedDate(_vm.stage.dateFinish))),
              ])
            : _c("span", [_vm._v("не задано")]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "td",
        { staticClass: "stage__col stage__col_status" },
        [
          _vm.hasAccess
            ? _c("Select", {
                attrs: {
                  name: "statuses",
                  items: _vm.stage.statuses,
                  active: _vm.stage.status,
                },
                on: {
                  selectChange: (statusId) =>
                    _vm.$emit(
                      "updateStage",
                      _vm.stage.set("status", statusId, true)
                    ),
                },
              })
            : _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.stage.statuses.find((s) => +s.id === _vm.stage.status)
                      ?.label || "не выбран"
                  )
                ),
              ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }